import { FormInitializerReturnTypeZod, ValidationMessageKeys } from 'src/Configuration/validation'
import { Installation, NewInstallationFormModel } from 'src/Libs/installations/models/installation.model'
import { EmsProductType } from 'src/Routes/Installation/InstallationModel'
import { z } from 'zod'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useMemo } from 'react'

const MIN_NAME_LENGTH = 3
const MAX_NAME_LENGTH = 100

export const useCreateNewInstallationFormInitializer = (
  installation?: Installation
): FormInitializerReturnTypeZod<NewInstallationFormModel, NewInstallationFormModel> => {
  const { t } = useCustomTranslation()

  const initialValues: NewInstallationFormModel = useMemo(() => {
    return {
      partnersInstallationName: installation?.partnersInstallationName ?? '',
      storageType: EmsProductType.qntm,
    }
  }, [installation])

  const validationSchema = z.object({
    partnersInstallationName: z
      .string({ message: t(ValidationMessageKeys.required) })
      .min(MIN_NAME_LENGTH, t(ValidationMessageKeys.lengthMin, { value: MIN_NAME_LENGTH }))
      .max(MAX_NAME_LENGTH, t(ValidationMessageKeys.lengthMax, { value: MAX_NAME_LENGTH }))
      .trim(),
    storageType: z.nativeEnum(EmsProductType, { message: t(ValidationMessageKeys.required) }),
  })

  return { initialValues, validationSchema }
}
